import styled from 'styled-components';

interface IProps {
  isYearly: boolean;
}

export const PricingStyled = styled.div<IProps>`
  .pricing-button-group-container {
    width: inherit;
    display: flex;
    justify-content: center;
  }
  .pricing-button-group {
    display: flex;
    padding: 4px;
    border-radius: 0.5rem;
    width: fit-content;
    background-color: rgba(227, 227, 227, 1);
  }

  .pricing-card-container {
    margin-top: 1rem;
  }

  .pricing-card {
    background-color: #fff;
    border-radius: 0.75rem;
    height: 100%;
    padding: 1rem;
    .w-100 {
      width: 100%;
    }
    &-content {
      min-height: ${({ isYearly }) => (isYearly ? '169px' : '149px')};
    }
    &-price {
      margin-top: 0.5rem;
      display: flex;
      align-items: center;
      gap: 5px;
      .save-text {
        color: #0c5132;
      }
      .previous-price {
        color: #8e1f0b;
        text-decoration: line-through;
      }
    }
    .price-extra-description {
      font-size: 10px;
    }
    .pricing-button {
      margin-top: 1rem;
      text-align: center;
    }
    .pricing-button-description {
      margin-top: 0.5rem;
      text-align: center;
    }
    .benefits {
      margin-top: 1rem;
    }
  }
  .benefits {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    &-title {
      display: flex;
      gap: 5px;
    }
    &-item {
      display: flex;
      align-items: center;
      gap: 5px;
      .Polaris-Icon {
        min-width: 20px;
        min-height: 20px;
        margin-bottom: 0;
      }
    }
    &-item:first-child {
      margin-top: 0;
      padding-top: 0;
    }

    &__horizontal {
      flex-direction: row;
      gap: 1rem;
    }
  }
  .wrap-discount-tag {
    display: flex;
    .Polaris-Tag__Button {
      display: flex;
    }
    .Polaris-Tag {
      background-color: #e4deff;
    }
    .Polaris-Tag__Button svg,
    .Polaris-Tag__TagText,
    .Polaris-Icon svg {
      fill: #742edb;
    }
    span {
      color: #742edb;
    }
  }
`;
